import type { AbstractIntlMessages, Locale } from 'next-intl'
import { NextIntlClientProvider } from 'next-intl'

export function CustomNextIntlClientProvider({
    locale,
    messages,
    children,
}: {
    locale?: Locale
    messages?: AbstractIntlMessages
    children: React.ReactNode
}) {
    return (
        <NextIntlClientProvider
            locale={locale}
            messages={messages}
            now={new Date()}
            timeZone="Africa/Cairo"
        >
            {children}
        </NextIntlClientProvider>
    )
}
